import {
  CCTVIcon,
  CashOnDeliveryIcon,
  ConveniantDeliveryIcon,
  NotificationIcon,
  OnTimeDeliveryIcon,
  QualityMattersIcon,
} from "../../../../constants/icons";

const styledLabel = (label: string) => `<span style="font-style: italic;" class="fw-500 text-center">${label}</span>`;

export const ourFeatures = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "On time, every time",
    isLock: false,
    description:
      "Our priority is your time. We know how important it is for you to get your things on time, every time.",
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Quality Matters",
    isLock: false,
    description:
      "We only work with the best quality products to ensure that you get the best experience possible.",
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Convenient Delivery",
    isLock: false,
    description:
      "We deliver to your doorstep, so you can just sit back and relax.",
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Cash On Delivery(COD)",
    isLock: false,
    description:
      "We provide you with the option to pay so that you can pay us only when you receive your product.",
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "Notification at Every Stage",
    isLock: false,
    description:
      "You will be updated and notified at every stage of the packing and moving process so that you know where your product is at all times.",
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: "CCTV Surveillance",
    isLock: false,
    description:
      "We have set up in our facility so that your product is always safe and secure.",
  },
];

export const individualWithFleetFeatures = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "Easy Signup Process",
    description:
      "Get started quickly online with a simple registration process and no additional costs.",
    isLock: false,
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Easy & Convenient Application",
    description:
      "Become today's delivery partners through an easy and convenient application process.",
    isLock: false,
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Training & support",
    description:
      "Dedicated driver partner assistance ensures support at every step of your journey.",
    isLock: false,
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Your Flexible Time",
    description:
      "Take charge of your ride and city with a flexible schedule, full-time or part-time options, and the freedom of using your vehicle.",
    isLock: false,
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "Monthly High Earning",
    description:
      "Boost your income with regular trips, ensuring consistent monthly earnings of 50,000+.",
    isLock: false,
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: "Competitive Pay",
    description:
      "Our company offers competitive pay to reward our delivery partners' hard work.",
    isLock: false,
  },
  {
    id: 6,
    icon: OnTimeDeliveryIcon,
    heading: "Weekly Payout",
    description:
      "You can enjoy hassle-free and regular cashouts with easy weekly payments.",
    isLock: false,
  },
  {
    id: 7,
    icon: QualityMattersIcon,
    heading: "Leave Policy",
    description:
      "Become today's delivery partners through an easy and convenient application process.",
    isLock: true,
  },
  {
    id: 8,
    icon: ConveniantDeliveryIcon,
    heading: "Essentials welcome kit",
    description:
      "Your welcome kit includes an ID card, safety kit, mobile cover, raincoat, hoodie, helmet, cap, water bottle, and shoes.",
    isLock: true,
  },
  {
    id: 9,
    icon: CashOnDeliveryIcon,
    heading: "Discount Bundle",
    description:
      "Enjoy discounts on fuel, vehicle purchases, and spare parts, including tyres.",
    isLock: true,
  },
  {
    id: 10,
    icon: NotificationIcon,
    heading: "Insurance",
    description:
      "Your insurance package includes accidental, medical, life, and vehicle coverage for comprehensive employee protection.",
    isLock: true,
  },
  {
    id: 11,
    icon: CCTVIcon,
    heading: "Community Building",
    description:
      "Join the movement and enjoy your city like never before, where boredom is far from your experience.",
    isLock: true,
  },
  {
    id: 12,
    icon: CCTVIcon,
    heading: "Incentive Income",
    description:
      "Join Delivery Partners for bonuses and incentives, exciting contests, and fulfilling missions to advance your career.",
    isLock: true,
  },
];

export const intraCityFeatures = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "Speed That Makes Superman Jealous",
    description:
      "Our lightning-quick drivers zip through the city like they know all the secret shortcuts. No address too tricky, no location too far!",
    isLock: false,
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Track Like You Track IPL Scores",
    description:
      "Watch your packages move through Ahmedabad in real-time! From crossing Ellis Bridge to navigating through Satellite, know exactly where your delivery is. It's like having your own tech savvy delivery ben.",
    isLock: false,
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Flexible Like a Garba Dancer",
    description:
      "Early morning deliveries before the Ahmedabad heat kicks in? Multiple stops across Ahmedabad? Special handling for your delicate items? Need a bike to zip through traffic faster than a kite on Uttarayan? A truck to move ahead your textile empire? We're as flexible as the rules at Law Garden during festival season!",
    isLock: false,
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Savings Sweeter Than Gol Papdi",
    description:
      "We know Amdavadi businesses  love smart deals! Our rates are so competitive; make your wallet do a happy dance. Budgeting? Easy peasy, lemon squeezy!",
    isLock: false,
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "Support That Speaks Your Language",
    description: "24/7 Support: “Aapdu Bhai Always Ready!” 📞 Stuck? Call our team — friendlier than your Parsi Colony neighbor.",
    isLock: false,
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: "Verified Drivers",
    description:
      "Our drivers are the rock stars of delivery, Ahmedabad's own logistics superheroes! They know the city better. Your goods are safer than in your tijori!",
    isLock: false,
  },
  // {
  //   id: 6,
  //   icon: OnTimeDeliveryIcon,
  //   heading: "Free Consultation and Registration",
  //   description:
  //     "Let us help you and give you the right business services and offer the best package.",
  //   isLock: false,
  // },
  // {
  //   id: 7,
  //   icon: QualityMattersIcon,
  //   heading: "Full Product Insurance",
  //   description:
  //     "We will compensate the value of lost items within three working days according to the rules. Maximum compensation - 50.000.",
  //   isLock: false,
  // },
  // {
  //   id: 8,
  //   icon: ConveniantDeliveryIcon,
  //   heading: "Order Scheduling",
  //   description:
  //     "Schedule your orders up to 2 days in advance for planned pick-up and drop.",
  //   isLock: false,
  // },
  // {
  //   id: 9,
  //   icon: CashOnDeliveryIcon,
  //   heading: "Multiple Drop Points",
  //   description:
  //     "Use one pick-up to deliver to multiple customers in the same order and save money.",
  //   isLock: false,
  // },
  // {
  //   id: 10,
  //   icon: NotificationIcon,
  //   heading: "24/7 Support",
  //   description:
  //     "Get instant help for all your order-related queries over live chat.",
  //   isLock: false,
  // },
  // {
  //   id: 11,
  //   icon: CCTVIcon,
  //   heading: "Customer Pays",
  //   description:
  //     "Pass on the delivery charges to your customer, who can pay when collecting the order.",
  //   isLock: false,
  // },
  // {
  //   id: 12,
  //   icon: CCTVIcon,
  //   heading: "Proof of Delivery",
  //   description: "Get proof of delivery via OTP & image verification.",
  //   isLock: false,
  // },
  // {
  //   id: 13,
  //   icon: NotificationIcon,
  //   heading: "Download the Android App",
  //   description: "Use the Android app to create & track orders easily.",
  //   isLock: false,
  // },
  // {
  //   id: 14,
  //   icon: CCTVIcon,
  //   heading: "Use the Web Dashboard",
  //   description:
  //     "Access our online dashboard using a mobile or desktop browser.",
  //   isLock: false,
  // },
  // {
  //   id: 15,
  //   icon: OnTimeDeliveryIcon,
  //   heading: "Low Fare",
  //   description: "Affordable shipping options with competitive pricing.",
  //   isLock: false,
  // },
  // {
  //   id: 16,
  //   icon: QualityMattersIcon,
  //   heading: "Fast Delivery",
  //   description: "Swift and punctual transportation services.",
  //   isLock: false,
  // },
  // {
  //   id: 17,
  //   icon: ConveniantDeliveryIcon,
  //   heading: "Reliable Service",
  //   description: "Consistent and trustworthy logistics solutions.",
  //   isLock: false,
  // },
  // {
  //   id: 18,
  //   icon: CashOnDeliveryIcon,
  //   heading: "Vehicle Variety",
  //   description: " Diverse fleet to handle various logistical requirements.",
  //   isLock: false,
  // },
  // {
  //   id: 19,
  //   icon: NotificationIcon,
  //   heading: "Cash on Delivery",
  //   description: "Same Day COD amount remittance to your account.",
  //   isLock: false,
  // },
  // {
  //   id: 20,
  //   icon: CCTVIcon,
  //   heading: "Buyout by our Courier",
  //   description: "Buy items directly from the courier delivering your package.",
  //   isLock: false,
  // },
  // {
  //   id: 21,
  //   icon: CCTVIcon,
  //   heading: "Additional Cost",
  //   description:
  //     "If you want labor we will provide with at an Additional Cost.",
  //   isLock: false,
  // },
];

export const partLoadAndFullLoadFeatures = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "Kifayati/discounted Rates",
    description: "Why pay for a full truck when you only need part of it? Our part-load services are as cost-effective as carpooling with friends – everyone gets where they need to go without breaking the bank!",
    isLock: false,
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Select Tamari Pasandgi no Transporter",
    description: "Shipper posts, transporters bid, and you choose the best offer – it’s as simple as picking the ripest mango from a vendor’s cart. Take charge of every step!",
    isLock: false,
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Live Tracking Dwara Maalni Mahiti",
    description: "Worried about your shipment? Track it in real-time through our web app or mobile app. It’s as easy as keeping an eye on your kite string during Uttarayan",
    isLock: false,
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Ghar Betha Pickup & Delivery",
    description: "Just like the morning newspaper that lands right at your doorstep. We come to you. No more hassle of dropping off or picking up goods.",
    isLock: false,
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "Full Support for Tatkalik Ukel",
    description: "Got questions or concerns? Our support team is just a call away, ready to assist you with the warmth of a cozy blanket on a chilly winter night.",
    isLock: false,
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: `Stay ${styledLabel("Befikr")}`,
    description: "Your goods are precious. We ensure they’re handled with the same care as a treasure chest – locked, guarded, and delivered intact.",
    isLock: false,
  },
  // {
  //   id: 6,
  //   icon: OnTimeDeliveryIcon,
  //   heading: "Commercial vehicle loans",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 7,
  //   icon: QualityMattersIcon,
  //   heading: "Attractive cash back",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 8,
  //   icon: ConveniantDeliveryIcon,
  //   heading: "Comprehensive logistics solutions",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 9,
  //   icon: CashOnDeliveryIcon,
  //   heading: "Material handling & packaging",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 10,
  //   icon: NotificationIcon,
  //   heading: "On-time delivery",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 11,
  //   icon: CCTVIcon,
  //   heading: "Pay for the space of your cargo",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 12,
  //   icon: CCTVIcon,
  //   heading: "Insights for better decisions",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 13,
  //   icon: NotificationIcon,
  //   heading: "Advance booking",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 14,
  //   icon: NotificationIcon,
  //   heading: "Lowest Out of Delivery Area (ODA) Pincode",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 15,
  //   icon: NotificationIcon,
  //   heading: "Appointment-based deliveries to warehouses and malls.",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 16,
  //   icon: NotificationIcon,
  //   heading: "e-POD, OTP verified delivery, and more value-added services",
  //   description: "",
  //   isLock: false,
  // },
  // {
  //   id: 17,
  //   icon: NotificationIcon,
  //   heading: "Reduced risk on Freight with consignment protection",
  //   description: "",
  //   isLock: false,
  // },
];

export const expressParcelBranchToBranchFeature = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "Next day morning branch delivery",
    description: "",
    isLock: false,
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Courteous and helping staff at our branches",
    description: "",
    isLock: false,
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Computerized receipt",
    description: "",
    isLock: false,
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Booking notification via SMS",
    description: "",
    isLock: false,
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "SMS notification when consignment unloaded at the destination branch",
    description: "",
    isLock: false,
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: "SMS notification at the time of delivery",
    description: "",
    isLock: false,
  },
  {
    id: 6,
    icon: OnTimeDeliveryIcon,
    heading: "All our branches are under CCTV surveillance",
    description: "",
    isLock: false,
  },
  {
    id: 7,
    icon: QualityMattersIcon,
    heading: "Monthly transaction report",
    description: "",
    isLock: false,
  },
  {
    id: 8,
    icon: ConveniantDeliveryIcon,
    heading: "Competitive rate",
    description: "",
    isLock: false,
  },
  {
    id: 9,
    icon: CashOnDeliveryIcon,
    heading: "Insurance service available",
    description: "",
    isLock: false,
  },
  {
    id: 10,
    icon: NotificationIcon,
    heading: "Credit Facility",
    description: "",
    isLock: false,
  },
  {
    id: 11,
    icon: CCTVIcon,
    heading: "Customer care number to resolve customer grievances",
    description: "",
    isLock: false,
  },
  {
    id: 12,
    icon: CCTVIcon,
    heading: "Cash on delivery service available",
    description: "",
    isLock: false,
  },
  {
    id: 13,
    icon: NotificationIcon,
    heading: "Bulk discount",
    description: "",
    isLock: false,
  },
  {
    id: 14,
    icon: NotificationIcon,
    heading: "Contact with local intracity transporter for door delivery",
    description: "",
    isLock: false,
  },
  {
    id: 15,
    icon: NotificationIcon,
    heading: "Closed container to safeguard against theft and rain",
    description: "",
    isLock: false,
  },
  {
    id: 16,
    icon: NotificationIcon,
    heading: "Pay to Pay",
    description: "",
    isLock: false,
  },
];

export const expressParcelDoorDeliveryFeature = [
  {
    id: 0,
    icon: OnTimeDeliveryIcon,
    heading: "Door-to-Door Delivery",
    description: "",
    isLock: false,
  },
  {
    id: 1,
    icon: QualityMattersIcon,
    heading: "Specialized courier service for remote locations",
    description: "",
    isLock: false,
  },
  {
    id: 2,
    icon: ConveniantDeliveryIcon,
    heading: "Bulk order creation",
    description: "",
    isLock: false,
  },
  {
    id: 3,
    icon: CashOnDeliveryIcon,
    heading: "Auto-documentation",
    description: "",
    isLock: false,
  },
  {
    id: 4,
    icon: NotificationIcon,
    heading: "Shipping rate calculator",
    description: "",
    isLock: false,
  },
  {
    id: 5,
    icon: CCTVIcon,
    heading: "AI recommendations",
    description: "",
    isLock: false,
  },
  {
    id: 6,
    icon: OnTimeDeliveryIcon,
    heading: "Real-time tracking",
    description: "",
    isLock: false,
  },
  {
    id: 7,
    icon: QualityMattersIcon,
    heading: "Affordable rates",
    description: "",
    isLock: false,
  },
  {
    id: 8,
    icon: ConveniantDeliveryIcon,
    heading: "Dedicated support",
    description: "",
    isLock: false,
  },
  {
    id: 9,
    icon: CashOnDeliveryIcon,
    heading: "Place an order in under 5 minutes",
    description: "",
    isLock: false,
  },
  {
    id: 10,
    icon: NotificationIcon,
    heading: "Address validation",
    description: "",
    isLock: false,
  },
  {
    id: 11,
    icon: CCTVIcon,
    heading: "Proof of Delivery",
    description: "",
    isLock: false,
  },
  {
    id: 12,
    icon: CCTVIcon,
    heading: "30+ years of experience with a wide network",
    description: "",
    isLock: false,
  }
];

export const ourFeaturesData = [
  {
    id: 0,
    page: "partners",
    partner: "Individual With Fleet",
    features: individualWithFleetFeatures,
  },
  {
    id: 1,
    page: "services",
    service: "Intracity",
    features: intraCityFeatures,
  },
  {
    id: 2,
    page: "services",
    service: "Part Load & Full Load",
    features: partLoadAndFullLoadFeatures,
  },
  {
    id: 3,
    page: "services",
    service: "Intercity Express Parcel",
    expressParcelType: "Branch to Branch",
    features: expressParcelBranchToBranchFeature,
  },
  {
    id: 4,
    page: "services",
    service: "Intercity Express Parcel",
    expressParcelType: "Door Delivery",
    features: expressParcelDoorDeliveryFeature,
  },
];